module.exports = __webpack_public_path__ + "img/swiper_right_hover.a56efb82.svg";